import { Typography } from "antd";
import DeleteButton from "components/DeleteButton";
import { LoadingIcon } from "components/Icons";
import { WidgetEmpty } from "components/widgets/WidgetEmpty";
import { isEmpty, isUndefined, map } from "lodash";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import useTriggerableEffect from "react-triggerable-effect";
import ExceptionAPI from "restAPI/ExceptionAPI";
import AuthorisedContainer from "components/AuthorisedContainer";
import { PermissionSetMap } from "constants/RBACConstants";

const DocumentsSection = forwardRef(function DocumentsSection({ id, disabled }, ref) {
  const [documents, setDocuments] = useState();
  const fetchDocuments = useTriggerableEffect(() => {
    setDocuments(undefined);
    const { promise, cancel } = ExceptionAPI.getDocuments(id);
    promise.then(setDocuments);
    return cancel;
  }, [id]);

  useImperativeHandle(ref, () => ({ refresh: fetchDocuments }), [
    fetchDocuments,
  ]);

  if (isUndefined(documents)) {
    return (
      <div className="text-center">
        <LoadingIcon />
      </div>
    );
  }
  if (isEmpty(documents)) {
    return (
      <WidgetEmpty description="No Documents" imgPath="/images/noproduct.png" />
    );
  }

  const onDeleteDocument = (documentId) => {
    return ExceptionAPI.deleteDocument(id, documentId).promise.then(() =>
      fetchDocuments()
    );
  };

  return (
    <div>
      {map(documents, (d) => {
        return (
          <div key={d.id} className="d-flex justify-content-between m-b-xs">
            <Typography.Link
              href={`/api/risk-register/${id}/documents/download?id=${d.id}`}
              target="_blank"
              className="text-ellipsis prevent-disable"
              title={d.fileName}
            >
              {d.fileName}
            </Typography.Link>
            <AuthorisedContainer permission={PermissionSetMap.UPDATE_EXCEPTION}>
            <DeleteButton
              disabled={disabled}
              confirmText="Delete"
              onDelete={() => onDeleteDocument(d.id)}
              />
            </AuthorisedContainer>
          </div>
        );
      })}
    </div>
  );
});

export default DocumentsSection;
